export interface MsgState {
  flagReminderMsg: string | null;
}

export const initialMsgState: MsgState = {
  flagReminderMsg: null
};
  